var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDocJpg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "52px",
    viewBox: "0 0 40 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04-Documents-uploadFile",
    transform: "translate(-1233.000000, -240.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-jpg",
    transform: "translate(1233.000000, 240.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F7F7F7",
    fillRule: "nonzero",
    points: "0 0 31.657864 0 40 8.44983179 40 52 0 52"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#36BB98",
    fillRule: "nonzero",
    points: "-4.13891144e-13 -1.15463195e-14 31.5169355 -1.15463195e-14 39.8219355 8.305 39.8219355 12.3016129 -4.13891144e-13 12.3016129"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EBECEC",
    fillRule: "nonzero",
    points: "31.5169355 -3.8191672e-13 31.5169355 8.305 39.8219355 8.305"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.44354839,2.62322581 L6.90483871,2.62322581 L6.90483871,7.19435484 C6.90483871,7.79225806 6.85290323,8.25225806 6.74709677,8.575 C6.60629032,8.99451613 6.35,9.33258065 5.97967742,9.58709677 C5.60935484,9.84080645 5.12080645,9.96903226 4.51306452,9.96903226 C3.80129032,9.96903226 3.25354839,9.77096774 2.87064516,9.37290323 C2.48612903,8.97483871 2.2933871,8.39032258 2.28967742,7.62112903 L3.67032258,7.45983871 C3.68741935,7.87129032 3.74564516,8.16177419 3.84967742,8.33129032 C4.0066129,8.59032258 4.24322581,8.71951613 4.56241935,8.71951613 C4.88241935,8.71951613 5.11112903,8.62709677 5.24370968,8.44064516 C5.37645161,8.25596774 5.44354839,7.87145161 5.44354839,7.28693548 L5.44354839,2.62322581 Z M8.4583871,9.83806452 L8.4583871,2.62322581 L10.7937097,2.62322581 C11.6795161,2.62322581 12.255,2.65822581 12.523871,2.73080645 C12.9370968,2.84016129 13.2822581,3.075 13.5619355,3.43806452 C13.8408065,3.80032258 13.9796774,4.26903226 13.9796774,4.84290323 C13.9796774,5.2866129 13.8990323,5.65774194 13.7393548,5.96 C13.5780645,6.26209677 13.3753226,6.49967742 13.1279032,6.67274194 C12.8812903,6.84403226 12.6295161,6.95790323 12.3740323,7.0133871 C12.026129,7.08241935 11.5241935,7.11741935 10.866129,7.11741935 L9.91951613,7.11741935 L9.91951613,9.83822581 L8.4583871,9.83822581 L8.4583871,9.83806452 Z M9.91967742,3.84241935 L9.91967742,5.89806452 L10.7130645,5.89806452 C11.2859677,5.89806452 11.6669355,5.85951613 11.8606452,5.78419355 C12.0533871,5.70806452 12.2048387,5.59048387 12.3141935,5.42741935 C12.4235484,5.26693548 12.4782258,5.07951613 12.4782258,4.86532258 C12.4782258,4.60177419 12.401129,4.38483871 12.2487097,4.21354839 C12.0935484,4.04225806 11.9008065,3.93467742 11.6641935,3.89080645 C11.491129,3.85935484 11.1433871,3.84241935 10.6198387,3.84241935 L9.91967742,3.84241935 L9.91967742,3.84241935 Z M18.5348387,7.18806452 L18.5348387,5.96887097 L21.6680645,5.96887097 L21.6680645,8.8466129 C21.3641935,9.14419355 20.9230645,9.40419355 20.3430645,9.63096774 C19.7658065,9.85596774 19.1793548,9.96887097 18.585,9.96887097 C17.831129,9.96887097 17.173871,9.81112903 16.6127419,9.49370968 C16.0541935,9.17629032 15.6329032,8.72096774 15.3504839,8.13112903 C15.0680645,7.54209677 14.9274194,6.8983871 14.9274194,6.20548387 C14.9274194,5.45241935 15.0851613,4.78451613 15.3990323,4.19822581 C15.7145161,3.61370968 16.1753226,3.16370968 16.7814516,2.85177419 C17.245,2.61145161 17.8195161,2.49225806 18.5072581,2.49225806 C19.4029032,2.49225806 20.1030645,2.68048387 20.6067742,3.05612903 C21.108871,3.43451613 21.4333871,3.95354839 21.5777419,4.61774194 L20.1262903,4.89032258 C20.0259677,4.53629032 19.835,4.25564516 19.5533871,4.04854839 C19.2754839,3.84419355 18.9258065,3.74112903 18.5062903,3.74112903 C17.8706452,3.74112903 17.3659677,3.94290323 16.9912903,4.34806452 C16.6166129,4.75241935 16.4282258,5.35209677 16.4282258,6.14645161 C16.4282258,7.00435484 16.6182258,7.64806452 16.9983871,8.0766129 C17.3793548,8.50419355 17.8759677,8.71935484 18.4929032,8.71935484 C18.7967742,8.71935484 19.1025806,8.6583871 19.4082258,8.54 C19.7156452,8.42080645 19.9774194,8.27467742 20.1970968,8.10258065 L20.1970968,7.18822581 L18.5348387,7.18822581 L18.5348387,7.18806452 Z",
    id: "Shape",
    fill: "#F8F8F8",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#79767B",
    fillRule: "nonzero",
    points: "7.70435484 17.7154839 32.1175806 17.7154839 32.1175806 42.1285484 7.70435484 42.1285484"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#36BB98",
    fillRule: "nonzero",
    points: "9.59951613 20.066129 30.2214516 20.066129 30.2214516 35.8353226 9.59951613 35.8353226"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "30.2214516 35.836129 22.9832258 26.1559677 18.3358065 32.3864516 14.8045161 29.7946774 9.59951613 35.836129"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F8F8F8",
    fillRule: "nonzero",
    cx: 15.2,
    cy: 24.1845161,
    r: 2.27435484
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDocJpg);
export default __webpack_public_path__ + "static/media/icDocJPG.b981cbfb5bf8628b8af8afd5381485bc.svg";
export { ForwardRef as ReactComponent };